export default __webpack_public_path__ + "static/media/enable-cam-ff-pc-2.daa898ed.png";